import {
  DashboardHeader,
  UiButton,
  UserProfile,
  WhiteCard,
} from "@/components";
import DashboardLayout from "@/components/layouts/dashboard-layout";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function DashboardProfile() {
  const navigate = useNavigate();

  return (
    <>
      <DashboardHeader subTitle="Bienvenue aux campagnes" showButtons={false} />

      <div className="py-4">
        <WhiteCard className="rounded-xl">
          <div className="">
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>

            <UserProfile />
          </div>
        </WhiteCard>
      </div>
    </>
  );
}
